import React, {useCallback, useEffect, useState} from "react";

type RootType = 2 | 3 | 5;

const labels: Record<RootType, string> = {
    2: "Carrée",
    3: "Cubique",
    5: "Cinquième"
};

const API_URL = "https://nguyen.alwaysdata.net/api.php";
const MAX_TRIES = 3;

const Game = () => {
    const [rootType, setRootType] = useState<RootType>(2);
    const [powerResult, setPowerResult] = useState<number | null>(null);
    const [guess, setGuess] = useState("");
    const [result, setResult] = useState<string | null>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [attempts, setAttempts] = useState(0);
    const [gameOver, setGameOver] = useState(false);

    const startGame = useCallback(async () => {
        setIsLoading(true);
        try {
            const response = await fetch(API_URL + `?root=${rootType}`, {
                credentials: "include"
            });

            if (!response.ok) throw new Error('Erreur réseau');
            const data = await response.json();
            setPowerResult(data.result);
            setResult(null);
            setGuess("");
            setAttempts(0);
            setGameOver(false);
        } catch (error) {
            console.error('Erreur lors du démarrage:', error);
            setResult("Erreur lors du chargement de la partie");
        } finally {
            setIsLoading(false);
        }
    }, [rootType]);

    const checkGuess = async () => {
        if (!guess.trim()) return;

        setIsLoading(true);
        try {
            const response = await fetch(API_URL, {
                method: "POST",
                credentials: "include",
                body: JSON.stringify({
                    guess: +guess,
                    root: rootType
                })
            });
            if (!response.ok) throw new Error('Erreur réseau');
            const data = await response.json();

            const newAttempts = attempts + 1;
            setAttempts(newAttempts);

            if (data.correct) {
                setResult("Bravo, bonne réponse !");
                setGameOver(true);
            } else if (newAttempts >= MAX_TRIES) {
                setResult(`Perdu ! C'était ${data.original}. Tu as épuisé tes ${MAX_TRIES} essais.`);
                setGameOver(true);
            } else {
                setResult(`Raté... Il te reste ${MAX_TRIES - newAttempts} essai(s)`);
                setGuess("");
            }
        } catch (error) {
            console.error('Erreur lors de la vérification:', error);
            setResult("Erreur lors de la vérification");
        } finally {
            setIsLoading(false);
        }
    };

    const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter' && !isLoading && !gameOver) {
            checkGuess();
        }
    };

    useEffect(() => {
        startGame();
    }, [startGame]);

    return (
        <div>
            <div>
                <h1><a href="#" className="title">Guess Root</a></h1>
            </div>
            <div className="game-container">
                <label htmlFor="root-select">Choisis la racine :</label>
                <select
                    id="root-select"
                    value={rootType}
                    onChange={e => setRootType(Number(e.target.value) as RootType)}
                    disabled={isLoading || !gameOver && attempts > 0}
                >
                    <option value={2}>Racine carrée</option>
                    <option value={3}>Racine cubique</option>
                    <option value={5}>Racine cinquième</option>
                </select>
                <h2>
                    Devine le nombre dont la racine {labels[rootType]} est : {powerResult ?? "?"}
                </h2>
                <p>Essais restants : {MAX_TRIES - attempts}</p>
                <input
                    type="number"
                    value={guess}
                    onChange={e => setGuess(e.target.value)}
                    onKeyPress={handleKeyPress}
                    placeholder="Ta réponse..."
                    disabled={isLoading || gameOver}
                />
                <button className="buttonRoot" onClick={checkGuess} disabled={isLoading || !guess.trim() || gameOver}>
                    {isLoading ? "Vérification..." : "Valider"}
                </button>
                {result && <p>{result}</p>}
                <button className="buttonRoot" onClick={startGame} disabled={isLoading}>Nouvelle partie</button>
            </div>
            <div id="exit">
                <a href="../index.php">Retour à la selection de jeu</a>
            </div>
        </div>
    );
};

export default Game;
